import { Injectable } from '@angular/core';
import {lastValueFrom} from 'rxjs';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SiteConfigService {

  config = new Map<string, string>();

  constructor(private api: ApiService) {
    this.loadConfig().then();
  }

  async loadConfig(): Promise<void> {
    const options = await lastValueFrom(this.api.siteSettings());
    for (const option of options) {
      this.config.set(option.setting, option.data);
    }

    console.log('Global EFI Maintenance =', this.isGlobalMaintenanceEFI());
  }

  getGlobalMaintenanceMessage(): string {
    return this.config.get('EFI_Maintenance_Banner');
  }

  isGlobalMaintenanceEFI(): boolean {
    return this.config.get('EFI_Maintenance_Banner') !== undefined;
  }

  isGlobalMaintenanceADS(): boolean {
    return this.config.get('ADS_Maintenance_Banner') !== undefined;
  }
}
